module.exports = __webpack_public_path__ + "media/flags/nz-7961d9cf.svg";